import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { defaultContainerSize, mq } from 'styles/mixins';

export const Section = styled.section`
  background-color: ${({ theme }) => theme.colors.light_grey};
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  ${defaultContainerSize};
  padding-top: 4rem;
  padding-bottom: 5rem;
`;

export const Title = styled.h3`
  font-weight: 400;
  font-family: ${({ theme }) => theme.font.questrial};
  font-size: 2rem;
  line-height: 2.5rem;
  color: ${({ theme }) => theme.colors.core_black};
  margin: 0 0 1.5rem 0;

  ${mq.medium(css`
    font-size: 3rem;
    line-height: 3.5rem;
    letter-spacing: -0.0125rem;
    margin-bottom: 3rem;
  `)};
`;

export const Stages = styled.div`
  display: none;
  flex-direction: row;
  overflow-x: scroll;
  gap: 1.875rem;
  padding-bottom: 0.5rem;
  align-items: flex-start;

  ${mq.medium(css`
    display: flex;
  `)};

  ::-webkit-scrollbar {
    height: 6px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
